import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Box from '../Box';
var breadTransitionAppearance = 'transform 0.1806s cubic-bezier(0.04, 0.04, 0.12, 0.96)';
var breadTransitionDisappearance = ' transform 0.3192s cubic-bezier(0.04, 0.04, 0.12, 0.96) 0.1008s';
var breadCrustTransitionAppearance = 'transition: transform 0.1806s cubic-bezier(0.04, 0.04, 0.12, 0.96)';
var breadCrustTransitionDisappearance = 'transition: transform 0.1806s cubic-bezier(0.04, 0.04, 0.12, 0.96)';
var IconWrapper = styled(Box).withConfig({
  displayName: "Hamburger__IconWrapper",
  componentId: "sc-1ehdppj-0"
})(["display:block;position:relative;top:0;width:", "px;height:", "px;cursor:pointer;transition:opacity 0.2s cubic-bezier(0.645,0.045,0.355,1);-webkit-tap-highlight-color:transparent;&:hover,&:active{opacity:.65;}"], function (props) {
  return props.size;
}, function (props) {
  return props.size;
});
var Bread = styled(Box).withConfig({
  displayName: "Hamburger__Bread",
  componentId: "sc-1ehdppj-1"
})(["position:absolute;top:0;left:0;width:100%;height:100%;"]);
var BreadTop = styled(Bread).withConfig({
  displayName: "Hamburger__BreadTop",
  componentId: "sc-1ehdppj-2"
})(["transition:", ";transform:none;", ""], breadTransitionAppearance, function (_ref) {
  var opened = _ref.opened;
  return opened && css(["transition:", ";transform:rotate(45deg);"], breadTransitionDisappearance);
});
var BreadBottom = styled(Bread).withConfig({
  displayName: "Hamburger__BreadBottom",
  componentId: "sc-1ehdppj-3"
})(["transition:", ";", ""], breadTransitionAppearance, function (_ref2) {
  var opened = _ref2.opened;
  return opened && css(["transition:", ";transform:rotate(-45deg);"], breadTransitionDisappearance);
});
var BreadCrust = styled(Box).withConfig({
  displayName: "Hamburger__BreadCrust",
  componentId: "sc-1ehdppj-4"
})(["display:block;width:100%;height:1px;position:absolute;left:0;"]);
var BreadCrustBottom = styled(BreadCrust).withConfig({
  displayName: "Hamburger__BreadCrustBottom",
  componentId: "sc-1ehdppj-5"
})(["bottom:", "px;transform:translateY(3px);transition:", ";", ""], function (props) {
  return props.size / 2;
}, breadCrustTransitionAppearance, function (_ref3) {
  var opened = _ref3.opened;
  return opened && css(["transition:", ";transform:none"], breadCrustTransitionDisappearance);
});
var BreadCrustTop = styled(BreadCrust).withConfig({
  displayName: "Hamburger__BreadCrustTop",
  componentId: "sc-1ehdppj-6"
})(["top:", "px;transform:translateY(-3px);transition:", ";", ""], function (props) {
  return props.size / 2;
}, breadCrustTransitionAppearance, function (_ref4) {
  var opened = _ref4.opened;
  return opened && css(["transition:", ";transform:none;"], breadCrustTransitionDisappearance);
});
var Hamburger = /*#__PURE__*/React.memo(function (_ref5) {
  var _ref5$opened = _ref5.opened,
      opened = _ref5$opened === void 0 ? false : _ref5$opened,
      color = _ref5.color,
      size = _ref5.size;
  return /*#__PURE__*/React.createElement(IconWrapper, {
    size: size
  }, /*#__PURE__*/React.createElement(BreadTop, {
    opened: opened
  }, /*#__PURE__*/React.createElement(BreadCrustTop, {
    size: size,
    opened: opened,
    bg: color
  })), /*#__PURE__*/React.createElement(BreadBottom, {
    opened: opened
  }, /*#__PURE__*/React.createElement(BreadCrustBottom, {
    size: size,
    opened: opened,
    bg: color
  })));
});
Hamburger.propTypes = {
  opened: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.number
};
Hamburger.defaultProps = {
  size: 20,
  color: 'navLabel'
};
export default Hamburger;